import { BaseErrorBody, isAxiosError, isBaseErrorBody } from './whoseError';
import { captureException } from '@sentry/node';
interface IResponse {
    isSuccess: boolean
}

export interface ISuccessResponse<T> extends IResponse {
    isSuccess: true,
    payload: T
}

export interface IErrorResponse<T extends BaseErrorBody> extends IResponse {
    isSuccess: false,
    error: T
}

export type TResponse<T, U extends BaseErrorBody> = ISuccessResponse<T> | IErrorResponse<U>

export function isSuccessResponse<T, U extends BaseErrorBody> (resp: TResponse<T, U>): resp is ISuccessResponse<T> {
    return resp.isSuccess;
}

export const UNKNOWN_ERROR_ERROR_CODE = 'UNKNOWN_ERROR' as const;

export const UNKNOWN_ERROR: BaseErrorBody = {
    code: UNKNOWN_ERROR_ERROR_CODE,
    message: 'Неизвестная ошибка',
} as const;

const NOT_FOUND = 404;

export function captureQueryError (e: Error): IErrorResponse<BaseErrorBody> {
    if (isAxiosError(e) && e.response && e.response?.status === NOT_FOUND) {
        return {
            isSuccess: false,
            error: {
                code: '404',
                message: '404 not found',
            },
        };
    }

    captureException(e);

    if (isAxiosError(e) && e.response) {
        if (isBaseErrorBody(e.response.data)) {
            return {
                isSuccess: false,
                error: e.response.data,
            };
        }

        return {
            isSuccess: false,
            error: {
                code: `${e.response.status}`,
                // @ts-ignore
                message: e.response.data,
            },
        };
    }

    return {
        isSuccess: false,
        error: UNKNOWN_ERROR,
    };
}
